 
<div *ngIf="pageDesignFlag">
  <div class="row" id="start-action-button-container" *ngIf="pageDesign.back_button">
    <img [src]="appDesignService.back_button_icon"  class="back-button" alt="" srcset="" (click)="loadPrevious()" [ngStyle]="appDesignService.getBackButtonStyle()">
  </div>
  <div id="cam-main-container" >
    <!-- CUSTOM CODE SECTION -->
    <div *ngIf="customDesign">
      <div [ngStyle]="pageDesign.style">
        <div [innerHTML]="htmlText | sanitizeHtml"></div>
      </div>
    </div>

    <!-- NON CUSTOM CODE SECTION -->
    <div *ngIf="!customDesign">
      <div #cameraContainer id="camera-container">
        <div *ngFor="let ele of pageDesign.element_flow" [ngStyle]="containerStyle">
          <div *ngIf="ele.type=='camera'">
            <!-- ACCESS DENIED MESSAGE -->
            <div id="accessMessage" *ngIf="cameraAccessDenied">
              <div class="row" id="start-action-button-container">
                <img [src]="appDesignService.back_button_icon" class="back-button" alt="" srcset=""  (click)="loadSelfieScreen()"  [ngStyle]="appDesignService.getBackButtonStyle()">
              </div>
              <p class="info-text" i18n>Please authorise access to the device camera</p>
              <img src="no-camera-access.png" alt="" width="50px">
            </div>

            <div id="cam-container" name="camera_view" [ngStyle]="getCameraViewPortStyle()">
              <webcam [height]="screen_height" [width]="screen_width" [trigger]="triggerObservable"
              (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch"
              [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" [imageQuality]="1"
              [mirrorImage]="mirrorImageStatus" (cameraSwitched)="cameraWasSwitched($event)" (initError)="handleInitError($event)"
              ></webcam>
              <div  *ngIf="enableOverlay" id="overlay-cover" [ngStyle]="overlayStyle"></div>
            </div>
            <p *ngIf="enableOverlay && cameraOverlayText!=null"  class="info-text">{{cameraOverlayText}}</p>
          </div>
          
          <div id="camera-buttons-container" [ngStyle]="camera_button_container_style"  *ngIf="ele.type=='button_container'">
            <div *ngFor="let btn of ele.buttons">
              <button mat-raised-button (click)="customService.loadSelfieHome()" *ngIf="btn.id=='close_button'" id="close-button" [ngStyle]="btn.style">
                <i class="material-icons capture-image">close</i>
              </button>
              <button mat-raised-button (click)="triggerSnapshot()" *ngIf="btn.id=='capture_image'" id="camera-button-btn" [ngStyle]="btn.style">
                <i class="material-icons capture-image" id="cam-icon">photo_camera</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
